module.exports = __webpack_public_path__ + "img/cameroon.51ff1a71.svg";